export default "__VITE_ASSET__LBSlgGjF__"